var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossCircle = function SvgCrossCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DC3545",
    clipPath: "url(#cross-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36a18 18 0 1 1 0-36 18 18 0 0 1 0 36m0-33.75a15.75 15.75 0 1 0 0 31.5 15.75 15.75 0 0 0 0-31.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.598 18 7.065-7.087a1.113 1.113 0 1 0-1.576-1.575L18 16.403l-7.087-7.065a1.114 1.114 0 0 0-1.575 1.575L16.403 18l-7.065 7.088a1.08 1.08 0 0 0 0 1.575 1.08 1.08 0 0 0 1.575 0L18 19.598l7.087 7.065a1.08 1.08 0 0 0 1.576 0 1.08 1.08 0 0 0 0-1.575z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgCrossCircle;